import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Box from "@mui/system/Box";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import EditIcon from "@mui/icons-material/Edit";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import "../pages/styles/RuleEnrollment.css";
import requests from "../utility/Requests";
import ConfigValuesDialog from "../components/ruleEnrollment/ConfigValuesDialog";
import ViewRulesDialog from "../components/ruleEnrollment/ViewRulesDialog";
import DescriptionDialog from "../components/ruleEnrollment/DescriptionDialog";
import SourceInputBox from "../components/ruleEnrollment/SourceInputBox";

function RuleEnrollment() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    window.location.reload();
  };

  const [indexForInputentries, setindexForInputentries] = useState(0);
  const [indexForOutputentries, setindexForOutputentries] = useState(1);

  const [isViewRulesClicked, setisViewRulesClicked] = useState(false);
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => {
    setOpen2(true);
    setisViewRulesClicked(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
    setisViewRulesClicked(false);
  };

  const [open3, setOpen3] = useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => setOpen3(false);

  const initalRulesRelationState = [
    {
      id: uuidv4().slice(0, 1),
      relation_type: "",
    },
  ];
  const [rules_relation, setRules_relation] = useState(
    initalRulesRelationState
  );
  // const [rules_relation, setRules_relation] = useState([
  //   {
  //     id: uuidv4().slice(0, 1),
  //     relation_type: "",
  //   },
  // ]);

  const [allFields, setAllFields] = useState([]);
  const [operator, setOperator] = useState([]);
  const [activeSourceFields, setActiveSourceFields] = useState([]);
  const [activeFields, setActiveFields] = useState([]);
  const [activeFields2, setActiveFields2] = useState([]);

  const redefineStatesToInitialState = () => {
    setInputFields([{ ...initalInputstate[0], id: 0 }]);
    setOutputFields(initialOutputState);
    setRule_description(initalRuleDescriptionState);
    setRule_title(initialRuleTitleState);
    setRules_relation(initalRulesRelationState);
    setisEditClickedonViewRules(false);
    setindexForInputentries(0);
    setindexForOutputentries(0);
  };

  const initalInputstate = [
    {
      // id: uuidv4().slice(0, 1),
      id: indexForInputentries,
      attribute1_id: "",
      attribute2_id: "",
      operator_id: "",
      source1_id: "",
      source2_id: "",
    },
  ];
  const [inputFields, setInputFields] = useState(initalInputstate);
  // const [inputFields, setInputFields] = useState([
  //   {
  //     // id: uuidv4().slice(0, 1),
  //     id: indexForInputentries,
  //     attribute1_id: "",
  //     attribute2_id: "",
  //     operator_id: "",
  //     source1_id: "",
  //     source2_id: "",
  //   },
  // ]);

  const [dataAfterEditOnRule, setdataAfterEditOnRule] = useState();
  console.log(inputFields);
  const [payloadInputFields, setPayloadInputFields] = useState([]);
  const [isEditClickedonViewRules, setisEditClickedonViewRules] =
    useState(false);
  const [dataForEdit, setDataForEdit] = useState();

  const [isDataFetched, setisDataFetched] = useState(false);
  console.log("is view clicked", isEditClickedonViewRules);

  const handleSubmit = (e) => {
    e.preventDefault();

    const conditionInputFields = inputFields.map((e) => {
      return {
        relation_type: e.relation_type + "",
      };
    });

    var findAndValue = conditionInputFields
      .map(({ relation_type }) => relation_type)
      .filter((v) => v !== "undefined");

    const payloadInputFields = inputFields.map((e) => {
      return {
        source1_id: e.source1_id + "",
        attribute1_id: e.attribute1_id + "",
        operator_id: e.operator_id + "",
        source2_id: e.source2_id + "",
        attribute2_id: e.attribute2_id + "",
      };
    });
    setPayloadInputFields(payloadInputFields);

    setLoader(true);
    axios
      .post(requests.save_rules_url, {
        request_type: isEditClickedonViewRules ? "update" : "Create",
        rule_title: rule_title,
        rule_description: rule_description,
        created_by: created_by,
        rules_input: payloadInputFields,
        rules_output: outputFields,
        rules_relation: findAndValue,
      })
      .then((res) => {
        setLoader(false);
        if (
          res &&
          rule_title &&
          rule_description &&
          created_by &&
          payloadInputFields &&
          outputFields &&
          findAndValue
        ) {
          toast.success(res.data.body);
          redefineStatesToInitialState();
        } else {
          toast.error(res.data.body);
        }
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
      });
  };

  console.log("input fileds --------->", inputFields);
  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i, key) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    console.log("rule enrollment condition ->", newInputFields);
    setInputFields(newInputFields);
  };

  console.log("rule relation", rules_relation);
  const handleAddFields = () => {
    setRules_relation([
      ...rules_relation,
      {
        id: uuidv4().slice(0, 1),
        relation_type: "",
      },
    ]);

    setInputFields([
      ...inputFields,
      {
        // id: uuidv4().slice(0, 1),
        id: indexForInputentries + 1,
        attribute1_id: "",
        attribute2_id: "",
        operator_id: "",
        source1_id: "",
        source2_id: "",
      },
    ]);

    setindexForInputentries((prevV) => prevV + 1);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
  };

  // OUTPUT
  const initialOutputState = [
    {
      // id: uuidv4().slice(0, 1),

      id: 0,
      rules_output_type: "",
      rules_output_key: "",
      rules_output_value: "",
    },
    {
      // id: uuidv4().slice(0, 1),
      id: 1,
      rules_output_type: "",
      rules_output_key: "",
      rules_output_value: "",
    },
  ];
  const [outputFields, setOutputFields] = useState(initialOutputState);
  // const [outputFields, setOutputFields] = useState([
  //   {
  //     // id: uuidv4().slice(0, 1),

  //     id: 0,
  //     rules_output_type: "",
  //     rules_output_key: "",
  //     rules_output_value: "",
  //   },
  //   {
  //     // id: uuidv4().slice(0, 1),
  //     id: 1,
  //     rules_output_type: "",
  //     rules_output_key: "",
  //     rules_output_value: "",
  //   },
  // ]);

  const setId = (indexForentries, key) => {
    setindexForInputentries((prev) => prev + 1);
    console.log(indexForInputentries);
    // return Math.max(key, indexForentries);
    return key;
  };

  const setIdOuput = (indexForentries, key) => {
    setindexForOutputentries((prev) => prev + 1);
    return key;
  };

  const handleChangeOutput = (id, event) => {
    const newOutputFields = outputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setOutputFields(newOutputFields);
  };

  const orAndOptions = [
    { key: "or", value: "OR" },
    { key: "and", value: "AND" },
  ];

  const outputTypeOptions = [
    { key: "success", value: "Success" },
    { key: "exception", value: "Exception" },
  ];

  const initialRuleTitleState = "";
  const [rule_title, setRule_title] = useState(initialRuleTitleState);
  // const [rule_title, setRule_title] = useState("");

  const name = sessionStorage.getItem("Name") || "";
  const [firstPart, secondPart] = name.split(" ", 2);

  // Set the initial state with the combined result
  const [created_by, setCreated_by] = useState(
    firstPart + " " + (secondPart || "")
  );
  const initalRuleDescriptionState = "";
  const [rule_description, setRule_description] = useState(
    initalRuleDescriptionState
  );
  // const [rule_description, setRule_description] = useState("");

  useEffect(() => {
    console.log("useeffect called");
    console.log(dataAfterEditOnRule);
    if (isEditClickedonViewRules && isDataFetched) {
      setRule_title(dataAfterEditOnRule.rule_title);
      setRules_relation(dataAfterEditOnRule.rules_relation);
      setRule_description(dataAfterEditOnRule.rule_description);
      // setOutputFields(dataAfterEditOnRule.rules_output);
      setOutputFields(
        dataAfterEditOnRule.rules_output.map((value, key) => ({
          ...value,
          id: setIdOuput(indexForOutputentries, key),
        }))
      );
      const updatedRulesInput = dataAfterEditOnRule.rules_input.map(
        (value, key) => {
          // Create the new object with the updated properties
          const IdForObj = setId(indexForInputentries, key);
          const obj =
            IdForObj == 0
              ? {
                  ...value,

                  id: IdForObj,
                }
              : {
                  ...value,
                  relation_type: dataAfterEditOnRule?.rules_relation[0],
                  id: IdForObj,
                };

          // Log the object to the console
          console.log("The object for input------->", obj);

          // Return the updated object
          return obj;
        }
      );

      // setInputFields(
      //   dataAfterEditOnRule.rules_input.map((value, key) => ({
      //     ...value,
      //     relation_type: dataAfterEditOnRule?.rules_relation[0],
      //     id: setId(indexForInputentries, key),
      //   }))
      setInputFields(updatedRulesInput);
    }
  }, [
    isEditClickedonViewRules,
    isDataFetched,
    dataAfterEditOnRule?.rules_input,
    dataAfterEditOnRule?.rules_output,
  ]);
  const handleAddFieldsOutput = () => {
    setOutputFields([
      ...outputFields,
      {
        id: indexForOutputentries + 1,
        rules_output_type: "",
        rules_output_key: "",
        rules_output_value: "",
      },
    ]);
    setindexForOutputentries((prevV) => prevV + 1);
  };

  const handleRemoveFieldsOutput = (id) => {
    const values = [...outputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setOutputFields(values);
  };

  const [loader, setLoader] = useState(false);

  console.log(dataAfterEditOnRule);

  console.log(inputFields);
  const history = useHistory();
  return (
    <>
      <form onSubmit={handleSubmit} className="rule-form">
        <Container className="form-container">
          <Grid container alignItems="center">
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <TextField
                className="rule-name-textfiled"
                hiddenLabel
                value={rule_title}
                variant="filled"
                placeholder="Rule Name"
                disabled={isEditClickedonViewRules ? true : false}
                size="lg"
                onChange={(e) => setRule_title(e.target.value)}
                InputProps={{
                  endAdornment: !isEditClickedonViewRules && (
                    <InputAdornment position="end">
                      <EditIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12} textAlign="right">
              <Button variant="contained" size="small" onClick={handleOpen3}>
                Add Description
              </Button>
              <DescriptionDialog
                open={open3}
                setRule_description={setRule_description}
                rule_description={rule_description}
                onClose={handleClose3}
              />
            </Grid>
          </Grid>

          <div className="divRuleContainer">
            <Box className="title">
              <h3 className="ruleHeader">INPUT</h3>
              <Button
                className="ruleContainer d-table-cell tar"
                variant="outlined"
                color="primary"
                onClick={handleOpen}
              >
                Configuration Management
              </Button>
            </Box>

            <ConfigValuesDialog
              open={open}
              onClose={handleClose}
              setDataForEdit={setDataForEdit}
              config_table_url={requests.config_table_url}
              config_form_url={requests.config_form_url}
              setisEditClickedonViewRules={setisEditClickedonViewRules}
            />

            <hr className="hr-style" />
            <Box className="input-container">
              {/* {inputFields.map((item) => {
                console.log("input field from rule enrollment--->", item); // Log the item to the console
                return (
                  <h1 key={item.id}>
                    {" "}
                   
                    {item.id} {item.source1_id} {item.attribute1_id}{" "}
                    {item.source2_id} {item.attribute2_id}
                  </h1>
                );
              })} */}

              {inputFields.map((inputField, index) => (
                <div key={inputField.id} className="divRuleBox">
                  {/* Draw Relation ====================================================================   */}
                  {index == 0 ? (
                    ""
                  ) : (
                    <Box className="condition-dropdown">
                      <TextField
                        className="ruleContainer"
                        select
                        label="Condition"
                        variant="outlined"
                        size="small"
                        name="relation_type"
                        // value={rules_relation}
                        value={inputField.relation_type}
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      >
                        {orAndOptions.map((opt) => (
                          <MenuItem key={opt.key} value={opt.key}>
                            {opt.value}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>
                  )}
                  {/* Draw Box ====================================================================   */}
                  <Box
                    component="form"
                    sx={{
                      "& > :not(style)": { width: "175px" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <SourceInputBox
                      key={inputField.id}
                      inputField={inputField}
                      setInputFields={setInputFields}
                      inputFields={inputFields}
                      currentId={inputField.id}
                      allFields={allFields}
                      setAllFields={setAllFields}
                      operator={operator}
                      source1_id={inputField.source1_id}
                      attribute1_id={inputField.attribute1_id}
                      source2_id={inputField.source2_id}
                      attribute2_id={inputField.attribute2_id}
                      setOperator={setOperator}
                      activeSourceFields={activeSourceFields}
                      isEditClickedonViewRules={isEditClickedonViewRules}
                      setActiveSourceFields={setActiveSourceFields}
                      activeFields={activeFields}
                      setActiveFields={setActiveFields}
                      activeFields2={activeFields2}
                      setActiveFields2={setActiveFields2}
                      handleChangeInput={handleChangeInput}
                      active_fields_url={requests.active_fields_url}
                      get_operator_url={requests.get_operator_url}
                    />

                    <Box className="button-box">
                      <Button variant="outlined" onClick={handleAddFields}>
                        <LibraryAddIcon />
                      </Button>
                      {index == 0 ? (
                        <Button variant="outlined" disabled>
                          <DeleteOutlineOutlinedIcon />
                        </Button>
                      ) : (
                        <Button
                          variant="outlined"
                          onClick={() => handleRemoveFields(inputField.id)}
                        >
                          <DeleteOutlineOutlinedIcon />
                        </Button>
                      )}
                    </Box>
                  </Box>
                </div>
              ))}
            </Box>
          </div>

          <div className="divRuleContainerOutput">
            <h3 className="ruleHeader">OUTPUT</h3>
            <hr className="hr-style" />
            {/* {outputFields.map((item) => (
              <p>{item.id}</p>
            ))} */}
            {outputFields.map((outputField, index) => (
              <div key={outputField.id}>
                <Box
                  component="form"
                  sx={{
                    "& > :not(style)": { width: "305px" },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <TextField
                    className="ruleContainer"
                    select
                    name="rules_output_type"
                    label="Type"
                    variant="outlined"
                    size="small"
                    value={outputField.rules_output_type}
                    onChange={(event) =>
                      handleChangeOutput(outputField.id, event)
                    }
                  >
                    {outputTypeOptions.map((opt) => (
                      <MenuItem key={opt.key} value={opt.key}>
                        {opt.value}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    className="ruleContainer"
                    name="rules_output_key"
                    label="Key"
                    variant="outlined"
                    size="small"
                    value={outputField.rules_output_key}
                    onChange={(event) =>
                      handleChangeOutput(outputField.id, event)
                    }
                  ></TextField>

                  <TextField
                    className="ruleContainer"
                    name="rules_output_value"
                    label="Message"
                    variant="outlined"
                    size="small"
                    value={outputField.rules_output_value}
                    onChange={(event) =>
                      handleChangeOutput(outputField.id, event)
                    }
                  ></TextField>

                  <Box className="button-box">
                    <Button variant="outlined" onClick={handleAddFieldsOutput}>
                      {/* <AddIcon /> */}
                      <LibraryAddIcon />
                    </Button>

                    {index == 0 ? (
                      <Button variant="outlined" disabled>
                        <DeleteOutlineOutlinedIcon />
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        onClick={() => handleRemoveFieldsOutput(outputField.id)}
                      >
                        <DeleteOutlineOutlinedIcon />
                      </Button>
                    )}
                  </Box>
                </Box>
              </div>
            ))}
          </div>
        </Container>

        <Box className="fixedBottomBar">
          <Container>
            <Grid container>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <Button
                  className="ruleContainer d-table-cell tar"
                  variant="contained"
                  color="primary"
                  onClick={handleOpen2}
                >
                  View Rules
                </Button>
                <Button
                  className="ruleContainer d-table-cell tar"
                  variant="contained"
                  color="primary"
                  onClick={() => history.push("/RuleCheckpoint")}
                >
                  Assign to Module
                </Button>
                {isViewRulesClicked && (
                  <ViewRulesDialog
                    open={open2}
                    setOpen2={setOpen2}
                    onClose={handleClose2}
                    setInputFields={setInputFields}
                    setdataAfterEditOnRule={setdataAfterEditOnRule}
                    dataAfterEditOnRule={dataAfterEditOnRule}
                    setisEditClickedonViewRules={setisEditClickedonViewRules}
                    setisDataFetched={setisDataFetched}
                    view_rules_url={requests.view_rules_url}
                    rule_toggle_url={requests.rule_toggle_url}
                    get_rule_def_url={requests.get_rule_def_url}
                    setLoader={setLoader}
                  />
                )}
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12} textAlign="right">
                <Button
                  className="ruleContainer d-table-cell tar"
                  variant="contained"
                  color="primary"
                  type="Submit"
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </form>
      {loader ? (
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      ) : (
        ""
      )}
    </>
  );
}

export default RuleEnrollment;
